import axios from "axios";

const csrApi = axios.create({
    baseURL: "/api",
    // headers: {
    //     "Content-Type": "application/json",
    //     Accept: "application/json",
    // },
});
export default csrApi;
